module.exports = __webpack_public_path__ + "static/media/Морозов Никита Денисович Через тернии - к звездам г. Санкт-Петербург-4.png";